<template>
  <div :class="themeStyleVs === 2 ? 'my_page black_version' : 'my_page'">
    <header id="hdMain">
      <navigation :text="'我的'" :searchShow="true"></navigation>
      <div class="nav_box">
        <ul>
          <li
            v-for="item in navList"
            :key="item.id"
            :class="navId === item.id ? 'active' : ''"
            @click="checkNav(item.id)"
          >
            {{ item.name }}
          </li>
        </ul>
      </div>
    </header>
    <div class="my_content">
      <Gz v-show="navId === 'gz' && !compareVersions(version , 9.68) " @diagShow="diagShow"></Gz>
      <Cf v-show="navId === 'cf' && !compareVersions(version , 9.68)" @diagShow="diagShow"></Cf>
      <Cl v-show="navId === 'cl' && !compareVersions(version , 9.68)"></Cl>
      <Mn v-show="navId === 'mn' && !compareVersions(version , 9.68)"></Mn>
      <Hc v-show="navId === 'hc'"></Hc>
      <Yl v-show="navId === 'yl' && !compareVersions(version , 9.68)" @diagShow="diagShow"></Yl>
    </div>
    <!-- <div class="my_content" v-else>
      <Gz v-if="navId === 'gz'" @diagShow="diagShow"></Gz>
      <Cf v-if="navId === 'cf'" @diagShow="diagShow"></Cf>
      <Cl v-if="navId === 'cl'"></Cl>
      <Mn v-if="navId === 'mn'"></Mn>
      <Hc v-if="navId === 'hc'"></Hc>
      <Yl v-if="navId === 'yl'" @diagShow="diagShow"></Yl>
    </div> -->
    <van-dialog class="version_box" v-model="show" confirmButtonText="我知道了">
      <div class="text_box">{{ digText }}</div>
    </van-dialog>
  </div>
</template>

<script>
import merge from 'webpack-merge';
import navigation from '@/components/navigation.vue';
import mixins from '@/mixins/index.js';
import Gz from '@/components/my_page/gz.vue';
import Cf from '@/components/my_page/cf.vue';
import Hc from '@/components/my_page/hc.vue';
import Cl from '@/components/my_page/cl.vue';
import Mn from '@/components/my_page/mn.vue';
import Yl from '@/components/my_page/yl.vue';
import { compareVersions } from '@/utils/format.js';
export default {
  name: 'My',
  mixins: [mixins],
  components: {
    navigation,
    Gz,
    Cf,
    Hc,
    Cl,
    Mn,
    Yl
  },
  data() {
    return {
      navList: [],
      navId: '',
      themeStyleVs: 1,
      show: false,
      digText: window.config.editionText,
      version: 0
    };
  },
  filters: {},
  created() {
    let u = navigator.userAgent;
    this.version = this.getUrlQuery('version');
    if (
      typeof DzhAppJs !== 'undefined' &&
      u.indexOf('iPhone') > -1 &&
      !compareVersions(this.getUrlQuery('version'),9.65)
    ) {
      let obj = { navBarHidden: 1, titleHidden: 1 };
      DzhAppJs.callAppWithChannelAndJsonAndCallbackFunc('setTitleStyle', JSON.stringify(obj), '');
    }

    if ( compareVersions(this.getUrlQuery('version'),9.68)) {
      this.navId = this.$route.query.myTab ? this.$route.query.myTab : 'hc';
      this.navList = [{ name: '回测', id: 'hc' }];
      this.navId = 'hc';
    } else {
      this.navId = this.$route.query.myTab ? this.$route.query.myTab : 'gz';
      this.navList = [
        { name: '关注', id: 'gz' },
        { name: '财富口令', id: 'cf' },
        { name: '策略', id: 'cl' },
        { name: '模拟交易', id: 'mn' },
        { name: '回测', id: 'hc' },
        { name: '最近浏览', id: 'yl' }
      ];
      this.navId = 'gz';
    }
    this.themeStyleVs = Number(this.getUrlQuery('themeStyleVs'));
    this.$store.commit('setMyTab', this.navId);

    if (this.$store.state.myTab) {
      this.navId = this.$store.state.myTab;
    } else {
      if ( compareVersions(this.getUrlQuery('version'),9.68)) {
        this.navId = 'hc';
        this.$store.commit('setMyTab', 'hc');
      } else {
        this.navId = 'gz';
        this.$store.commit('setMyTab', 'gz');
      }
    }
  },
  mounted() {},
  methods: {
    compareVersions,
    checkNav: function (id) {
      this.$store.commit('setMyTab', id);
      this.$store.commit('setSmallTab', '');
      this.$router.push(
        {
          query: merge(this.$route.query, { myTab: id })
        },
        () => {}
      );
      // this.$router.push(`${this.$route.path}?token=${this.getUrlQuery('token')}&tab=${id}`);
      this.navId = id;
    },
    diagShow: function (e) {
      this.show = e;
    }
  },
  beforeDestroy() {}
};
</script>
<style lang="less" scoped>
.my_page {
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  left: 0;
  header {
    padding-top: 44px;
    background-color: #fff;
    .nav_box {
      width: 100%;
      ul {
        width: 100%;
        overflow: hidden;
        overflow-x: auto;
        white-space: nowrap;
        display: flex;
        display: inline-block;
        scrollbar-width: none; /* firefox */
        -ms-overflow-style: none; /* IE 10+ */
        &::-webkit-scrollbar {
          display: none;
        }
        li {
          display: inline-block;
          padding: 6px 12px;
          font-size: 14px;
          color: #222;
          &.active {
            position: relative;
            font-weight: 600;
            &::before {
              content: ' ';
              position: absolute;
              bottom: 0;
              left: 0;
              width: 100%;
              border-bottom: 1px solid #286df7;
            }
          }
        }
      }
    }
  }
  .my_content {
    width: 100%;
    height: calc(100vh - 120px);
    background-color: #f4f4f4;
    box-sizing: border-box;
  }
}
.black_version {
  #hdMain {
    background-color: #181a23;
    .navget_main {
      color: #e4e9fe;
    }
    .nav_box {
      ul {
        li {
          color: #e4e9fe;
          &.active {
            position: relative;
            &::before {
              border-bottom: 1px solid #3b85fe;
            }
          }
        }
      }
    }
  }
  .my_content {
    background-color: #0c0f13;
  }
}
</style>
<style lang="less">
.version_box {
  .van-dialog__content {
    padding: 20px 0;
    text-align: center;
  }
}
.black_version {
  .van-popup {
    background-color: #1d202d;
  }
  .popup_box {
    .controls_ul {
      li {
        border-bottom: 1px solid rgba(255, 255, 255, 0.1) !important;
        color: #aab9d1 !important;
        &:last-child {
          border: none !important;
        }
      }
    }
    .close_box {
      color: #aab9d1 !important;
      border-top: 1px solid rgba(255, 255, 255, 0.1) !important;
    }
  }
  .van-dialog {
    background-color: #181a23;
    .van-dialog__content {
      color: #e4e9fe;
    }
    .van-button--default {
      background-color: #181a23;
    }
  }
  .version_box {
    background-color: #181a23;
    .van-dialog__header {
      color: #e4e9fe;
    }
  }
  .dialog_box {
    background-color: #181a23;
    .van-dialog__message {
      color: #aab9d1 !important;
    }
    .van-button--default {
      background-color: #181a23;
    }
    [class*='van-hairline']::after {
      border-color: #6b7687 !important;
    }
  }
}
</style>
